import React, { useContext, useEffect } from "react";
import { AppContext } from "../../../context/AppContext";
import {SubmitToSalesForce} from "../../../helpers/Api";
import { useRouterMatch } from "../../../helpers/Hooks";

import "./ActionButtons.scss";

const ActionButtons = ({onSalesForceResponse}) => {
  const [salesForceResponse, getSalesForceResponse] = SubmitToSalesForce();
  const { translations, disableButton, setDisableButton, showButtonCheckMark, setShowButtonCheckMark } = useContext(AppContext);

  const { params } = useRouterMatch("/:guid/:SalesforceID");
  useEffect(() => {
    if(salesForceResponse.data) {
      const statusCode = salesForceResponse.data.status_code;
      onSalesForceResponse(statusCode);
      if(statusCode === 200) {
        setDisableButton(true);
        setShowButtonCheckMark(true);
      } else {
        setDisableButton(false);
        setShowButtonCheckMark(false);
      }
    }
  }, [salesForceResponse, onSalesForceResponse]);

  useEffect(() => {
    setDisableButton(disableButton);
    setShowButtonCheckMark(disableButton);
  }, [disableButton])


  return (
    <div
      disabled={disableButton}
      className="action-buttons-container"
    >
      <button
        disabled={disableButton}
        onClick={() => {
            getSalesForceResponse(params.guid, params.SalesforceID);        
        }}
        className={"ars-link-button" + ( disableButton && showButtonCheckMark ? " complete" : "")}
        type="button"
      >
        {/* <span className= {disableButton ? "" : "tracking-out-contract-bck"}> {translations.phoneSearchBar.salesForceButton}</span> */}
        <span> {translations.phoneSearchBar.salesForceButton}</span>
        <div className={ showButtonCheckMark ? "checkmark draw show" : "hide"} />
      </button>
      
    </div>
  );
};

export default ActionButtons;
